"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { Menu, X } from "lucide-react";
import { useSidebar } from "@/context/AdminSidebarContext";
import AuthButton from "@/components/SidebarAuthButton";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Academics", href: "/academics" },
  { label: "Publications", href: "/publications" },
  { label: "News", href: "/news" },
  { label: "Gallery", href: "/gallery" },
  { label: "Contact Us", href: "/contact" },
];

const PublicMenu = () => {
  const { isMobileMenuOpen, toggleMobileMenu, closeMobileMenu } = useSidebar();
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1025;
      setIsMobileView(mobile);
      if (!mobile) closeMobileMenu();
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [closeMobileMenu]);

  const handleLinkClick = () => {
    if (isMobileView) closeMobileMenu();
  };

  return (
    <>
      

      {/* Background Overlay */}
      {isMobileView && isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-30 lg:hidden"
          onClick={closeMobileMenu}
        />
      )}

<aside
  className={` lg:hidden overflow-x-hidden
    overflow-y-auto scrollbar-hide 
    bg-[linear-gradient(rgba(4,9,30,0.98),rgba(4,9,30,0.93))]
    bg-cover bg-center 
    w-[100vw] fixed right-0 top-0 h-screen 
    transition-all duration-300 ease-out z-40
    ${isMobileView ? "right-transform" : ""}
    ${isMobileMenuOpen 
      ? "translate-x-0 opacity-100" 
      : "translate-x-full opacity-0 pointer-events-none lg:translate-x-0 lg:opacity-100"}
  `}
>

          <div className="w-full">
          <nav className="nav-container mt-[10px] md:mt-1 mb-4 flex flex-row -mr-2">
            <div className="flex-1">
              <img
              src="/assets/images/logo_2.png"
              alt="Logo"
              className="w-[300px] md:w-[450px] mb-2"
              height={0} 
              width={0}  
              
            />
            </div>
            
        {isMobileView && (
        <div className='block lg:hidden align-middle items-center md:pl-2'>
          <button
            className=" text-white lg:hidden z-50"
            onClick={closeMobileMenu}
            aria-label="Close Menu"
          >
            <X size={24} />
          </button>
          
        </div>
          
          
        )}
          </nav>

          <div className="flex flex-col gap-2 ">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                href={link.href}
                onClick={handleLinkClick}
                className="block text-white pt-4 pb-2 pl-12 px-3 border-t-[0.25px] border-gray-400 font-light"
              >
                {link.label}
              </Link>
            ))}

            <div className="pt-4 pl-8 border-t-[0.25px]">
              <AuthButton />
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default PublicMenu;
